import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/no_team_image.png'


const _withScopeId = n => (_pushScopeId("data-v-78680c89"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "no-team-image",
  alt: "Illustration of group of people"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "h6" }, "Create a organisation to enable features and invite team members", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Create team ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppPanel = _resolveComponent("AppPanel")!

  return (_openBlock(), _createBlock(_component_AppPanel, {
    class: _normalizeClass(["create-team-panel", [ _ctx.borderless && 'create-team-panel--borderless' ]])
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createVNode(_component_AppButton, {
        size: "large",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ModalHandlerService.open('create-team')))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}